module.exports = __webpack_public_path__ + "img/earth1.ded5724.jpg";